const initialState = {
  questionnaires: [],
  currentQuestionnaireIndex: 0,
  currentQuestionIndex: 0,
  score: 0,
  userAnswers: [],
};

const quizReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_QUESTIONNAIRES":
      return { ...state, questionnaires: action.payload };

    case "NEXT_QUESTION":
      return {
        ...state,
        currentQuestionIndex: state.currentQuestionIndex + 1,
      };

    case "ANSWER_QUESTION": {
      const { currentQuestionnaireIndex, currentQuestionIndex } = state;
      const currentQuestionnaire =
        state.questionnaires[currentQuestionnaireIndex];
      const currentQuestion =
        currentQuestionnaire?.questions[currentQuestionIndex];
      const isAnswerCorrect =
        action.payload === currentQuestion?.correctAnswer;

      return {
        ...state,
        score: isAnswerCorrect ? state.score + 1 : state.score,
        userAnswers: [
          ...state.userAnswers,
          {
            questionnaireIndex: currentQuestionnaireIndex,
            questionIndex: currentQuestionIndex,
            isAnswerCorrect,
          },
        ],
        currentQuestionIndex: currentQuestionIndex + 1,
      };
    }

    default:
      return state;
  }
};

export default quizReducer;
